import { render } from "./ZonaFormPage.vue?vue&type=template&id=12ddcf14&scoped=true"
import script from "./ZonaFormPage.vue?vue&type=script&lang=js"
export * from "./ZonaFormPage.vue?vue&type=script&lang=js"

import "./ZonaFormPage.vue?vue&type=style&index=0&id=12ddcf14&scoped=true&lang=css"
import "./ZonaFormPage.vue?vue&type=style&index=1&id=12ddcf14&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ddcf14"]])

export default __exports__